export default __webpack_public_path__ + "static/media/cif-rs.457fc634.svg";